export default __webpack_public_path__ + "static/media/404_img.f3480d46.png";